import React, { useState } from 'react'
import classNames from 'classnames'
import Icon from 'react-ionicons/lib/MdStar'
import { graphql, compose } from 'react-apollo'
import MUTATION_ADD_TO_WISHLIST from './AddToWishlist.gql'
import MUTATION_REMOVE_FROM_WISHLIST from './RemoveFromWishlist.gql'
import getContext from 'context'

const WishlistButton = (props) => {
  const { t } = getContext()
  const [
    isActive,
    setState
  ] = useState(props.isActive)
  const { RemoveFromWishlist, AddToWishlist } = props

  const handleChange = () => {
    if (isActive) {
      RemoveFromWishlist({ variables: { id: props.id } })
    }    else {
      AddToWishlist({ variables: { id: props.id } })
    }

    setState(!isActive)
  }

  const classes = classNames('py-4 rounded-full outline-none text-lg', {
    'text-orange bg-white border border-orange hover:bg-orange hover:text-white px-20': !isActive,
    'text-grey-dark bg-white border border-white hover:text-grey-dark hover:underline': isActive
  })

  return (
    <button className={classes} onClick={handleChange}>
      {isActive && (
        <div className='flex items-center w-full'>
          <Icon className='fill-current mr-2 text-orange' fontSize='24' />
          {t('buttons.wishlist-remove')}
        </div>
      )}

      {!isActive && (
        <div className='flex items-center w-full'>
          {t('buttons.wishlist-add')}
        </div>
      )}
    </button>
  )
}

WishlistButton.defaultProps = {
  isActive: true
}

export default compose(
  graphql(MUTATION_ADD_TO_WISHLIST, { name: 'AddToWishlist' }),
  graphql(MUTATION_REMOVE_FROM_WISHLIST, { name: 'RemoveFromWishlist' })
)(WishlistButton)
